module.exports = __webpack_public_path__ + "img/iv_b4_img1.089772d9.png";